const messages = {
  title: 'Gateway-time-outfout',
  description: 'Het spijt ons zeer voor het ongemak. Het lijkt erop dat onze server om de een of andere reden geen tijdige reactie heeft ontvangen.',
  backHomeButton: 'Terug naar dashboard'
}

export default {
  messages
}
